import { useState, useCallback } from 'react';
import { message } from 'antd';

export const useApi = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const callApi = useCallback(async (apiFunc) => {
    setLoading(true);
    setError(null);
    try {
      const result = await apiFunc();
      return result;
    } catch (err) {
      setError(err.message);
      message.error(`API Error: ${err.message}`);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  return { loading, error, callApi };
};
